import React from 'react'

export const useFormattedNumber = (value?: number) => {
  return React.useMemo(
    () => (value || value === 0 ? new Intl.NumberFormat().format(value) : ''),
    [value],
  )
}
